<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="caruana_instantiated"
    :start_opened="caruana_instantiated"
  >
    <div v-if="caruana_instantiated">
      <performances-chart-caruana
        key="caruana_iterations_chart"
        :project_id="project_id"
        :is_caruana="true"
        :is_cv="false"
        :is_single_cv="false"
        :tracking_infos="caruana_search_tracking_info"
        :nb_iters="nb_caruana_iters"
      />

      <performances-table-caruana
        key="caruana_iterations_table"
        :project_id="project_id"
        :is_caruana="true"
        :is_cv="false"
        :is_single_cv="false"
        :tracking_infos="caruana_search_tracking_info"
      />
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import PerformancesChartCaruana from './performances_chart_caruana.vue'
import PerformancesTableCaruana from './performances_table_caruana.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentCaruana',
  components: {
    UnrollElement,
    PerformancesChartCaruana,
    PerformancesTableCaruana,
  },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid', 'nb_caruana_iters'],

  computed: {
    _() {
      return _
    },

    caruana_instantiated() {
      return !_.isUndefined(this.caruana_search_tracking_info)
    },
  },

  watch: {
    caruana_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
